import React, { useState } from 'react';
import { useFileDownloadService } from '../../../libs/hooks/useFileDownloadService';

interface DownloadCitationDocumentProps {
    link: string;
    query: string;
}

export const DownloadCitationDocument: React.FC<DownloadCitationDocumentProps> = ({ link, query }) => {
    const fileDownloadService = useFileDownloadService();
    const [downloading, setDownloading] = useState(false);

    const handleClick = async () => {
        setDownloading(true);
        try {
            if (fileDownloadService) {
                const blob = await fileDownloadService.getFileAsBlob(link, query);
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                window.URL.revokeObjectURL(url);
                setDownloading(false);
            } else {
                alert('File download service is not available.');
                setDownloading(false);
            }
        } catch (e) {
            alert('Failed to open the document.');
            setDownloading(false);
        }
    };


    return (
        <button
            style={{
                marginBottom: 8,
                color: '#0078d4',
                background: 'none',
                border: 'none',
                cursor: downloading ? 'not-allowed' : 'pointer',
                textDecoration: 'underline',
                fontWeight: 'bold',
                opacity: downloading ? 0.6 : 1,
                visibility:'hidden'
            }}
            onClick={() => { void handleClick(); }}
            disabled={downloading}
        >
            {downloading ? 'Downloading...' : 'See in the PDF document'}
        </button>
    );

};